var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"layout-header-nav",style:({'line-height': _vm.lineHeight})},_vm._l((_vm.navList),function(nav){return _c('li',{key:nav.name,ref:"navItem",refInFor:true,staticClass:"layout-header-nav-item",class:{active: !!_vm.matchedMap[nav.path]},on:{"click":function($event){return _vm.onNavItemClick(nav)}}},[_vm._v(_vm._s(nav.label))])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a2b903ec","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Layout/MainNav.vue
// module id = null
// module chunks = 